
import { Box, Divider, IconButton, styled as muiStyled, Tab, Tabs } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import React, { useContext } from 'react';
import { M3LabelSmall } from './TextStyles';
import { DrawerContext } from '../../utils/context';

const StyledTabs = muiStyled(Tabs)(({ theme }) => ({
  minHeight: '36px',
  marginTop: '32px',
  marginBottom: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.info.main,
  },
  '& .MuiTabs-scrollButtons': {
    width: '28px',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '16px',
  },
}));

export const CustomTabs = ({ variant = 'scrollable', scrollButtons = 'auto', ...props }) => (
  <StyledTabs variant={variant} scrollButtons={scrollButtons} {...props} />
);

export const CustomTab = muiStyled(Tab)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '20px',
  minWidth: 'auto',
  minHeight: '36px',
  padding: '6px 32px',
  letterSpacing: '0.1px',
  [theme.breakpoints.down('sm')]: {
    padding: '6px 16px',
  },
  color: theme.palette.text.secondary,
  '&.Mui-selected': {
    color: theme.palette.info.main,
  },
}));

export const PaddingBox = muiStyled('div')`
    width: 10px;
    height: 10px;
`;
export const PaddingBoxSmall = muiStyled('div')`
    width: 8px;
    height: 8px;
`

export const SpacedRow = ({ children, style, ...props }) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      style={style}
      {...props}
    >
      {children}
    </Box>
  );
};

export const PageHeader = ({ children, style, ...props }) => {
  const toggleDrawer = useContext(DrawerContext);
  const childArray = React.Children.toArray(children);
  const firstChild = childArray[0];
  const restChildren = childArray.slice(1);

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      gap={1}
      style={style}
      sx={{
        paddingTop: { xs: '20px', sm: '0px' },
        paddingBottom: { xs: '8px', sm: '0px' },
      }}
      {...props}
    >
      {toggleDrawer ? (
        <>
          <Box display="flex" alignItems="center" flexShrink={0}>
            <IconButton onClick={toggleDrawer} sx={{ color: 'black', flexShrink: 0 }}>
              <MenuIcon />
            </IconButton>
            <PaddingBox />
            {firstChild}
          </Box>
          {restChildren}
        </>
      ) : (
        children
      )}
    </Box>
  );
};

export const Row = muiStyled('div')`
    display: flex;
    align-items: center;
`;

export const Space = ({ children, direction = 'horizontal', gap = 0, style = {} }) => {
  return (
    <Box
      display="flex"
      flexDirection={direction === 'vertical' ? 'column' : 'row'}
      gap={gap}
      style={{alignItems: 'center', ...style}}
    >
      {children}
    </Box>
  );
};

export function LabelDivider({label}) {
    return (
        <div>
            <Divider textAlign="left">
                <M3LabelSmall
                    variant="caption"
                    sx={{ color: "text.secondary" }}
                    >
                    {label}
                </M3LabelSmall>
            </Divider>
        </div>
    )
}

export const Column = muiStyled('div')`
    display: flex;
    flex-direction: column;
`